module.exports = __webpack_public_path__ + "img/logo-type.9f37ed8f.svg";